import {
  type StoryblokImage,
  type StoryBlokRichText,
} from '@cinch-nx/data-storyblok'
import cx from 'classnames'
import Image from 'next/legacy/image'
import React from 'react'
import { RichText } from '../rich-text'
import styles from './text-inline-image.module.css'

export interface TextInlineImageProps {
  body: StoryBlokRichText
  image: StoryblokImage
  imagePosition: 'left' | 'right'
  imageShape?: 'rectangle' | 'square'
}

export const TextInlineImage: React.FC<TextInlineImageProps> = ({
  body,
  image,
  imagePosition,
  imageShape,
}) => (
  <div
    className={cx(styles.container, {
      [styles.imageLeft]: imagePosition === 'left',
    })}
    data-testid="text-inline-image-container"
  >
    {image?.filename && (
      <div
        className={
          imageShape === 'rectangle'
            ? styles.imageRectangleContainer
            : styles.imageSquareContainer
        }
      >
        <Image
          src={image.filename}
          className={styles.image}
          alt={image.alt ?? undefined}
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </div>
    )}

    {body && (
      <RichText
        text={body}
        className={styles.body}
        data-testid="text-inline-rich-text"
      />
    )}
  </div>
)
